<fuse-loading-bar />

<div class="flex w-full flex-auto flex-col">
  <div class="flex flex-auto flex-col">
    <router-outlet></router-outlet>
  </div>
</div>
